import { render } from "./FeatureUpsellModal.vue?vue&type=template&id=74ec8890&scoped=true"
import script from "./FeatureUpsellModal.vue?vue&type=script&lang=js"
export * from "./FeatureUpsellModal.vue?vue&type=script&lang=js"

import "./FeatureUpsellModal.vue?vue&type=style&index=0&id=74ec8890&lang=css"
import "./FeatureUpsellModal.vue?vue&type=style&index=1&id=74ec8890&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/82161804/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ec8890"]])

export default __exports__